import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import { useNavigate } from "react-router-dom";

export default function ProfileComplete() {
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (user) {
      const { data: profile } = await supabase
        .from("user_profiles")
        .select("*")
        .eq("user_id", user.id)
        .single();

      setUserData(profile);
    }
  };

  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        backgroundColor: "#fafafa",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          width: "100%",
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #e5e5e5",
          padding: "4rem 3rem",
          textAlign: "center",
        }}
      >
        {/* Success Icon */}
        <div
          style={{
            fontSize: "64px",
            marginBottom: "1.5rem",
          }}
        >
          ✓
        </div>

        {/* Headline */}
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "1rem",
          }}
        >
          Your Profile is Complete!
        </h1>

        {/* Subheading */}
        <p
          style={{
            fontSize: "18px",
            color: "#525252",
            marginBottom: "3rem",
            lineHeight: "1.6",
          }}
        >
          Thank you for joining Collavo. Your profile has been saved and you're
          all set up as a service provider.
        </p>

        {/* Profile Preview Card */}
        <div
          style={{
            backgroundColor: "#fafafa",
            padding: "2rem",
            borderRadius: "8px",
            marginBottom: "3rem",
            textAlign: "left",
          }}
        >
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            {userData?.full_name || "Your Profile"}
          </h2>
          <p
            style={{
              fontSize: "15px",
              color: "#525252",
              marginBottom: "1rem",
            }}
          >
            {userData?.bio1 || "Service Provider"}
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#737373",
            }}
          >
            {userData?.bio2?.substring(0, 100)}...
          </p>
        </div>

        {/* What Happens Next */}
        <div
          style={{
            textAlign: "left",
            marginBottom: "3rem",
          }}
        >
          <h3
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "1rem",
            }}
          >
            What happens next?
          </h3>
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              "We're currently building the church-facing features",
              "You'll be notified when churches can start browsing profiles",
              "In the meantime, you can update your profile anytime",
            ].map((item, index) => (
              <li
                key={index}
                style={{
                  fontSize: "15px",
                  color: "#525252",
                  marginBottom: "0.75rem",
                  paddingLeft: "1.5rem",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    color: "#000",
                  }}
                >
                  {index + 1}.
                </span>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            onClick={() => navigate(`/profile/${userData?.user_id}`)}
            style={{
              backgroundColor: "#000",
              color: "#fff",
              padding: "14px 32px",
              fontSize: "15px",
              fontWeight: "600",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#333")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#000")
            }
          >
            View My Profile
          </button>

          <button
            onClick={() => navigate("/explore")}
            style={{
              backgroundColor: "transparent",
              color: "#1a1a1a",
              padding: "14px 32px",
              fontSize: "15px",
              fontWeight: "500",
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#a3a3a3";
              e.currentTarget.style.backgroundColor = "#fafafa";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            Browse Profiles
          </button>
        </div>
      </div>
    </div>
  );
}
